// accident api
import listManualAccidentStates from '@drivesally/sally-fn/lib/accident/api/listManualStates.api.accident';

// components
import {FullScreenLoader} from '@drivesally/sally-ui';

// driver redux actions
import {set as setAction} from '../../redux/actions';

// propTypes
import PropTypes from 'prop-types';

// react
import React, {Component} from 'react';

// react redux
import {connect} from 'react-redux';

class AccidentManualStateLoaderContainer extends Component {
  static propTypes = {
    children: PropTypes.node,
    loadingManualStates: PropTypes.bool,
  };

  state = {
    loading: true,
  };

  componentDidMount() {
    this.loadManualAccidentStates();
  }

  loadManualAccidentStates = async () => {
    const {dispatch} = this.props;

    this.setState({loading: true});
    dispatch(setAction({loadingManualStates: true}));

    try {
      const {
        manual_state_choices: manualStates,
      } = await listManualAccidentStates();
      dispatch(setAction({loadingManualStates: false, manualStates}));
      this.setState({loading: false});
    } catch (error) {
      dispatch(setAction({loadingManualStates: false}));
      this.setState({loading: false});
    }
  };

  render() {
    const {children} = this.props;
    const {loading} = this.state;
    return !loading ? children : <FullScreenLoader />;
  }
}

export default connect((state) => ({
  loadingManualStates: state.accident.loadingManualStates,
}))(AccidentManualStateLoaderContainer);
